export default {
  mapRightClick: {
    'options': 'Opciones',
    'addDestinationToRoute': 'Añadir como destino',
    'directionsFromHere': 'Direcciones desde aquí',
    'directionsToHere': 'Direcciones hasta aquí',
    'nonStopDirectionsToHere': 'Direto para aquí',
    'addRouteStop': 'Añadir parada aquí',
    'centerHere': 'Centralizar aquí',
    'addAsIsochroneCenter': 'Añadir como el centro de la isócrona',
    'inspectDataOnOSM': 'Ver datos en OSM'
  }
}
